module.exports = __webpack_public_path__ + "img/mouth-01.6ecf4af4.svg";